import { PRODUCTION_DOMAIN } from "lib/constants";
import { parseLinkToEnv } from "lib/utils/parseLinkToEnv";
import { isAbsoluteUrl } from "./isAbsoluteUrl";
import { isPipelineUrl } from "./isPipelineUrl";
import { PipelineDataType } from "./localStorage/getPipelineLocalStorageData";

const getPipelineLink = (path: string, localStorageData: PipelineDataType = {}) => {
  const isAbsolute = isAbsoluteUrl(path);

  // Add query parameters to the pipeline URL
  if (isPipelineUrl(path)) {
    /**
     * If relative path, we need to provide a base URL to the URL constructor
     * so we are using the production domain as the base URL
     * this will be ignored since we will exclude the domain from the final URL
     * */
    const url = isAbsolute ? new URL(path) : new URL(path, PRODUCTION_DOMAIN);

    for (const [param, value] of Object.entries(localStorageData)) {
      url.searchParams.set(param, value || "");
    }

    // If the URL is absolute, we need to rewrite the domain to the correct environment
    if (isAbsolute) {
      return parseLinkToEnv(url.toString());
    }

    // If the URL is relative, we need to return the pathname and search
    return url.pathname + url.search;
  }

  // Rewrite the domain to the correct environment if an absolute URL is passed
  if (isAbsolute) {
    return parseLinkToEnv(path);
  }

  return path;
};

export { getPipelineLink };
